import React, { useState } from "react";
import "./HeroVideo.css";
import { useTranslation } from "react-i18next"; // Added
import logo from "../../Asset/Icons/logo_transparent.png";

import img1 from "../../Asset/Images/ivideo.png";
import img2 from "../../Asset/Images/ivideo3.png";
import img3 from "../../Asset/Images/ivideo2.png";
import img4 from "../../Asset/Images/ivideo4.png";
import img5 from "../../Asset/Images/ivideo5.png";
import img6 from "../../Asset/Images/iv6.jpeg";
import img7 from "../../Asset/Images/iv1.jpeg";
import img8 from "../../Asset/Images/iv2.jpeg";

const gallery = [
  { img: img1, youtubeId: "xmjXnsJQSWc" },
  { img: img2, youtubeId: "fxamyvK6Ox4" },
  { img: img3, youtubeId: "NlTYk8tRdC4" },
  { img: img4, youtubeId: "5oeRc2Xb5vI" },
  { img: img5, youtubeId: "SOtltIM3B_M" },
  { img: img6, youtubeId: "4f78O35fVFw" },
  { img: img7, youtubeId: "7QEQaOZNik4" },
  { img: img8, youtubeId: "hldi1or1dEI" }
];

const HeroVideo = () => {
  const { t } = useTranslation(); // Initialize translation
  const [openVideo, setOpenVideo] = useState(null);

  const openVideoModal = (videoId) => setOpenVideo(videoId);
  const closeVideoModal = () => setOpenVideo(null);

  return (
    <>
      <section className="video-mosaic-section">
        <div className="video-mosaic">
          {gallery.map((item, index) => (
            <div
              key={index}
              className={`mosaic-item item-${index}`}
              onClick={() => openVideoModal(item.youtubeId)}
            >
              <img 
                src={item.img} 
                alt={`${t("gallery_image_alt")} ${index + 1}`} 
                loading="lazy" 
              />
              <div className="image-play-btn">▶</div>
            </div>
          ))}

          {/* Center Logo */}
          <div className="center-logo-wrapper">
            <div className="logo-inner">
               <img src={logo} alt={t("brand_name")} />
            </div>
          </div>
        </div>
      </section>

      {/* VIDEO MODAL */}
      {openVideo && (
        <div className="video-modal" onClick={closeVideoModal}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="modal-close" 
              onClick={closeVideoModal}
              aria-label={t("close_modal")}
            >
              ✕
            </button>
            <div className="iframe-container">
                <iframe
                src={`https://www.youtube.com/embed/${openVideo}?autoplay=1&rel=0`}
                title={t("video_player_title")}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HeroVideo;